import { render, staticRenderFns } from "./GenericMedia.vue?vue&type=template&id=face96ee&scoped=true"
import script from "./GenericMedia.vue?vue&type=script&lang=js"
export * from "./GenericMedia.vue?vue&type=script&lang=js"
import style0 from "./GenericMedia.vue?vue&type=style&index=0&id=face96ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "face96ee",
  null
  
)

export default component.exports